var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13H17L12 18L7 13H10.75V8H13.25V13ZM15.75 3H3.25V23H20.75V8H15.75V3ZM0.75 1.74C0.75 1.055 1.30875 0.5 1.99875 0.5H17L23.25 6.75V24.2412C23.2512 24.4054 23.22 24.5682 23.1582 24.7203C23.0965 24.8724 23.0053 25.0108 22.8901 25.1277C22.7748 25.2446 22.6377 25.3376 22.4864 25.4015C22.3352 25.4654 22.1729 25.4989 22.0088 25.5H1.99125C1.66297 25.4977 1.34877 25.3664 1.11652 25.1344C0.884272 24.9023 0.752618 24.5883 0.75 24.26V1.74Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.3a5f8072b1e3aeed572a0f609bd9029d.svg";
export { ForwardRef as ReactComponent };